import { useAsync } from 'react-use'

import { useAccountContext } from 'components/contexts/AccountContext'
import { fetchAccount } from 'utils'
import { SupportContactPreviewProps } from '../types/SupportContactPreviewProps'

const useSupportContact = (): { loading: boolean; contact: null | Partial<SupportContactPreviewProps> } => {
  const { accountKey } = useAccountContext()

  const { value, loading } = useAsync(() => {
    if (!accountKey) {
      return Promise.resolve(null)
    }
    return fetchAccount(accountKey).then((acc) => {
      if (!acc || (!acc.partnerSupportContact && !acc.parentContactDetails)) {
        return null
      }
      return acc.parentContactDetails || acc.partnerSupportContact
    })
  }, [accountKey])
  return { contact: value, loading }
}

export default useSupportContact
